import styled, { keyframes } from 'styled-components'

let theme = {
  theme_color: {
    shadow_primary_red: '102',
    shadow_primary_green: '133',
    shadow_primary_blue: '218',
    shadow_primary_alpha: '0.34',
    text: '#63799B'
  }
}

if (window.localStorage.getItem('whitelabel-theme')) {
  theme = JSON.parse(window.localStorage.getItem('whitelabel-theme'))
}

export const HandToFront = keyframes`
  0% {
    opacity: 0;
    z-index: -1;
  }
  50% {
    margin-top: -175px;
    opacity: .5;
  }
  80% {
    z-index: 0;
  }
  100% {
    opacity: 1;
  }
`

export const Modal = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  padding: 20px;

  background-color: rgba(255, 255, 255, .74);
  backdrop-filter: blur(8px);
  opacity: 0;
  pointer-events: none;

  transition: .3s;

  &.active {
    opacity: 1;
    pointer-events: unset;
    overflow-y: auto;
  }

  .iconAlert {
    position: absolute;
    pointer-events: none;
    margin-top: -7px;
  }

  .animationImgToFront {
    animation: ${HandToFront} .7s ease-in;
  }
`

export const Content = styled.div`
  position: relative;
  width: fit-content;
  min-width: 560px;
  margin: auto;
  padding: 21px 49px 42px 49px;

  background-color: #fff;
  border-radius: 10px;

  
  -webkit-box-shadow: 0px 3px 99px 0px ${props => `rgba(${theme.theme_color?.shadow_primary_red},${theme.theme_color?.shadow_primary_green},${theme.theme_color?.shadow_primary_blue},${theme.theme_color?.shadow_primary_alpha})` || 'var(--shadowPrimary)'};
  -moz-box-shadow: 0px 3px 99px 0px ${props => `rgba(${theme.theme_color?.shadow_primary_red},${theme.theme_color?.shadow_primary_green},${theme.theme_color?.shadow_primary_blue},${theme.theme_color?.shadow_primary_alpha})` || 'var(--shadowPrimary)'};
  box-shadow: 0px 3px 99px 0px ${props => `rgba(${theme.theme_color?.shadow_primary_red},${theme.theme_color?.shadow_primary_green},${theme.theme_color?.shadow_primary_blue},${theme.theme_color?.shadow_primary_alpha})` || 'var(--shadowPrimary)'};

  &.internal {
    max-width: 793px;
  }

  @media (max-width: 1050px) {
    min-width: unset;
    padding: 21px 20px 42px 20px;
  }
  
  @media (max-width: 875px) {
    max-width: 100%;
  }
  
  @media (max-width: 680px) {
    width: 100%;
  }
`

export const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const FlexContainerRelative = styled(FlexContainer)`
  position: relative;
  align-items: center;
`

export const Title = styled.h2`
  font-family: 'Poppins', sans serif;
  font-size: 24px;
  text-align: center;
  margin: 90px 80px 10px 80px;
  color: ${props => theme.theme_color?.text || 'var(--text)'};

  @media (max-width: 680px) {
    font-size: 20px;
    margin: 90px 0px 10px;
  }
`

export const Description = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 0.9375rem;
  text-align: center;
  line-height: 17px;
  color: ${props => theme.theme_color?.text || 'var(--text)'};

  margin-bottom: 34px;
  max-width: 539px;
`
